<ng-container *ngFor="let item of items; let i = index">
  <!-- Elementos sin submenús -->
  <li *ngIf="(!item.SubItems || item.SubItems.length == 0) && (!item.Class.includes(excludedLinkClass) || (excludedLinkClass == '' && excludedLinkClass != item.Class))" class="nav-item" id="{{item.Id}}">
    <a href="javascript:void(0);" [routerLink]="item.Url" [routerLinkActive]="'active'" class="nav-link">
      {{item.Title | translate}}
    </a>
  </li>

  <!-- Elementos con submenús (collapse) -->
  <li *ngIf="item.SubItems?.length > 0 && (!item.Class.includes(excludedLinkClass) || (excludedLinkClass === '' && excludedLinkClass !== item.Class))" class="nav-item" id="{{ item.Id }}">
    <a class="nav-link" href="javascript:void(0);" (click)="toggleMenuCollapse(item.Id)" [attr.aria-expanded]="menuCollapsedItems[item.Id] === true" [attr.aria-controls]="'submenu' + item.Id">
      {{ item.Title | translate }}
    </a>

    <ul [id]="'submenu' + item.Id" [ngbCollapse]="!menuCollapsedItems[item.Id] === true" class="navbar-nav">
      <ng-container *ngFor="let subItem of item.SubItems">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="subItem.Url" routerLinkActive="active">
            {{ subItem.Title | translate }}
          </a>
        </li>
      </ng-container>
    </ul>
  </li>
</ng-container>

<ng-container *ngIf="hasLogout">
  <li class="nav-item border-top mt-2 pt-2" id="help-center">
    <a class="nav-link nav-link-icon help-link" href="javascript:void(0);" (click)="openHelpModal()">
      <img src="assets/images/icons/ico-help.svg" [alt]="'HEADER.HELP' | translate" width="16"> {{'HEADER.HELP' | translate}}
    </a>
  </li>
  <li class="nav-item" id="legal">
    <a class="nav-link nav-link-icon help-link" href="javascript:void(0);" (click)="openLegalModal()">
      {{'HEADER.LEGAL' | translate}}
    </a>
  </li>
  <li class="nav-item" id="logout">
    <a role="button" (click)="logout()" class="nav-link nav-link-icon logout-link">
      <img src="assets/images/icons/ico-exit.svg" [alt]="'HEADER.LOGOUT' | translate" width="15"> {{'HEADER.LOGOUT' | translate}}
    </a>
  </li>
</ng-container>